import Burger from './Burger';

document.addEventListener('DOMContentLoaded', () => {
  // init burger
  const burgerElement = document.getElementById('burger');
  if (!burgerElement) {
    return;
  }

  const burger = new Burger(burgerElement, {
    control: burgerElement,
    target: document.getElementById('navigations'),
  });

  // Gestion de la touche Échap
  function handleEscapeKey(event) {
    if (event.key === 'Escape') {
      const header = document.querySelector('header');
      if (header && header.classList.contains('is-open')) {
        burger.close();
      }
    }
  }

  // Check resize
  let isMounted = null;

  function checkWindowsWidth() {
    if (window.innerWidth <= 1260) {
      burger.close();

      document.addEventListener('keydown', handleEscapeKey);

      if (isMounted !== true) {
        burger.mount();
        isMounted = true;
      }
    } else {
      document.removeEventListener('keydown', handleEscapeKey);
      if (isMounted !== false) {
        burger.unmount();
        isMounted = false;
      }
    }
  }

  checkWindowsWidth();

  window.onresize = function(event) {
    checkWindowsWidth();
  };
});
